/**
 * 🚀 Project Transform Utils
 * Feature-Sliced Design - Entities Layer
 * 
 * Project 도메인 전용 변환 유틸리티 함수들
 * 이전 packages/shared/utils/data-transform-utils에서 FSD entities로 이주
 */ // FSD entities 간 import (허용됨)
import { transformUserSummaryToAuthorInfo } from '@edusense/entities-user';
import { processMediaFileUrl } from '@edusense/entities-media';
/**
 * Transforms an API project response to the Project type used in the UI.
 * Processes media URLs and handles authentication context.
 * 
 * @param apiProject API project response object
 * @returns Transformed Project object
 */ export var transformProject = function(apiProject) {
    var basicInfo = apiProject.basicInfo;
    var metaInfo = apiProject.metaInfo;
    var statsInfo = apiProject.statsInfo;
    var userInfo = apiProject.userInfo;
    var fileInfo = apiProject.fileInfo;
    var userInteraction = apiProject.userInteraction;
    var authContext = apiProject.authContext;
    var authorInfo = transformUserSummaryToAuthorInfo(userInfo);
    var processedZipPath = processMediaFileUrl(fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.projectZipFilePath);
    var _basicInfo_id, _basicInfo_title, _basicInfo_description, _fileInfo_mediaPaths, _metaInfo_tags, _basicInfo_createdAt, _statsInfo_viewCount, _statsInfo_likeCount, _userInteraction_likedByCurrentUser, _fileInfo_projectZipFileSize;
    return {
        id: (_basicInfo_id = basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.id) !== null && _basicInfo_id !== void 0 ? _basicInfo_id : '',
        title: (_basicInfo_title = basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.title) !== null && _basicInfo_title !== void 0 ? _basicInfo_title : '',
        description: (_basicInfo_description = basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.description) !== null && _basicInfo_description !== void 0 ? _basicInfo_description : '',
        mediaUrls: (_fileInfo_mediaPaths = fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.mediaPaths) !== null && _fileInfo_mediaPaths !== void 0 ? _fileInfo_mediaPaths : [],
        tags: (_metaInfo_tags = metaInfo === null || metaInfo === void 0 ? void 0 : metaInfo.tags) !== null && _metaInfo_tags !== void 0 ? _metaInfo_tags : [],
        author: authorInfo,
        createdAt: (_basicInfo_createdAt = basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.createdAt) !== null && _basicInfo_createdAt !== void 0 ? _basicInfo_createdAt : '',
        updatedAt: basicInfo === null || basicInfo === void 0 ? void 0 : basicInfo.updatedAt,
        views: parseInt(String((_statsInfo_viewCount = statsInfo === null || statsInfo === void 0 ? void 0 : statsInfo.viewCount) !== null && _statsInfo_viewCount !== void 0 ? _statsInfo_viewCount : '0')),
        likes: parseInt(String((_statsInfo_likeCount = statsInfo === null || statsInfo === void 0 ? void 0 : statsInfo.likeCount) !== null && _statsInfo_likeCount !== void 0 ? _statsInfo_likeCount : '0')),
        comments: 0,
        isLiked: (_userInteraction_likedByCurrentUser = userInteraction === null || userInteraction === void 0 ? void 0 : userInteraction.likedByCurrentUser) !== null && _userInteraction_likedByCurrentUser !== void 0 ? _userInteraction_likedByCurrentUser : false,
        reposts: 0,
        isOwner: (authContext === null || authContext === void 0 ? void 0 : authContext.isCurrentUser) === true,
        isAuthorized: (authContext === null || authContext === void 0 ? void 0 : authContext.isAuthenticated) === true,
        projectZipFilePath: processedZipPath,
        projectZipFileSize: (_fileInfo_projectZipFileSize = fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.projectZipFileSize) !== null && _fileInfo_projectZipFileSize !== void 0 ? _fileInfo_projectZipFileSize : undefined
    };
};
